import axios from "axios";


const state = {
  user: {}
};
const getters = {
  user(state) {
    return state.user;
  },
};
const mutations = {
  SET_USER(state, payload) {
    state.user = payload;
  },
};
const actions = {
  async fetchUser({ commit }) {
    await axios
      .get("https://api.uzgeouniver.uz/api/login/")
      .then(response => {
        commit("SET_USER", response.data);
      })
      .catch((error) => {
        console.log(error); 
      });
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};